import React, { useState } from "react";

import { ADMIN_APP_NAME } from "./appConfig";
import { supabase } from "./supabaseClient";

const MIN_PASSWORD_LENGTH = 8;

export default function PasswordSetupPanel({ hasSession, onComplete, onBackToLogin }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    setMessage("");
    setError("");

    if (!hasSession) {
      setError("Länken är ogiltig eller har gått ut. Be om ett nytt åtkomstmejl.");
      return;
    }

    if (password.length < MIN_PASSWORD_LENGTH) {
      setError(`Lösenordet måste vara minst ${MIN_PASSWORD_LENGTH} tecken.`);
      return;
    }

    if (password !== confirmPassword) {
      setError("Lösenorden matchar inte.");
      return;
    }

    setSubmitting(true);

    const { error: updateError } = await supabase.auth.updateUser({
      password
    });

    if (updateError) {
      setError(updateError.message || "Kunde inte spara lösenordet.");
      setSubmitting(false);
      return;
    }

    setMessage("Lösenordet är sparat. Du skickas vidare till admin.");
    setSubmitting(false);
    onComplete();
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <p className="eyebrow">{ADMIN_APP_NAME}</p>
        <h1>Välj lösenord</h1>
        <p className="auth-description">
          Skapa ditt lösenord för att logga in och hantera dina webbplatser.
        </p>

        {!hasSession ? (
          <>
            <p className="feedback feedback--error">
              Länken är ogiltig eller har gått ut. Be om ett nytt åtkomstmejl.
            </p>
            <div className="auth-actions">
              <button type="button" className="button button--primary" onClick={onBackToLogin}>
                Till inloggning
              </button>
            </div>
          </>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="field">
              <span>Nytt lösenord</span>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="new-password"
                minLength={MIN_PASSWORD_LENGTH}
                required
              />
            </label>
            <label className="field">
              <span>Bekräfta lösenord</span>
              <input
                type="password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                autoComplete="new-password"
                minLength={MIN_PASSWORD_LENGTH}
                required
              />
            </label>
            {error ? <p className="feedback feedback--error">{error}</p> : null}
            {message ? <p className="feedback feedback--success">{message}</p> : null}
            <div className="auth-actions">
              <button type="submit" className="button button--primary" disabled={submitting}>
                {submitting ? "Sparar..." : "Spara lösenord"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
